import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginGuard} from './guards/login.guard';

import {FullLayoutComponent} from './layouts/full-layout.component';
import {SimpleLayoutComponent} from './layouts/simple-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [LoginGuard],
    data: {
      title: 'Início'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './pages/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'estudo',
        loadChildren: './pages/estudo/estudo.module#EstudoModule'
      },
      {
        path: 'gestao',
        loadChildren: './pages/gestao/gestao.module#GestaoModule'
      },
      {
        path: 'relatorios',
        loadChildren: './pages/relatorios/relatorios.module#RelatoriosModule'
      },
      {
        path: 'servicos',
        loadChildren: './pages/servicos/servicos.module#ServicosModule'
      },
      {
        path: 'suporte',
        loadChildren: './pages/suporte/suporte.module#SuporteModule'
      },
    ],
  },
  {
    path: 'login',
    component: SimpleLayoutComponent,
    data: {
      title: 'Login'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/login/login.module#LoginModule'
      },
    ],
  },
  {
    path: 'spe-acesso/:id/:cnpj/:userName',
    component: SimpleLayoutComponent,
    data: {
      title: 'Primeiro Acesso SPE'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/spe-acesso/spe-acesso.module#SpeAcessoModule'
      },
    ],
  },
  {
    path: 'erro-550',
    component: SimpleLayoutComponent,
    canActivate: [LoginGuard],
    data: {
      title: 'Erro 550'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/erros/550/err550.module#Err550Module'
      },
    ],
  },
  {
    path: 'erro-404',
    component: SimpleLayoutComponent,
    canActivate: [LoginGuard],
    data: {
      title: 'Erro 404'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/erros/404/err404.module#Err404Module'
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'erro-404',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
